module.exports = __webpack_public_path__ + "img/goods14.d2377b57.jpg";